// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"61f33552","513":"5b81c115","703":"f72372fe"}[chunkId] + ".chunk.js";
};